<div class="logout-button-container">
  <button mat-button class="logout-button" (click)="logoutKeycloak()">
    <mat-icon>exit_to_app</mat-icon> Αποσύνδεση
  </button>
</div>

<!-- Loading indicator while checking for previous applications -->
<div *ngIf="loadingProgress" class="loading-overlay">
  <div class="loading-spinner"></div>
  <p>Παρακαλώ περιμένετε...</p>
</div>


<!-- <div *ngIf="showImmediateRecallPrompt && previousApplication" class="immediate-recall-overlay">
  <div class="immediate-recall-container">
    <div class="immediate-recall-content">
      <h3>Προηγούμενη Αίτηση</h3>
      
      <p>Υπάρχει ήδη αίτηση με το ΑΦΜ <strong>{{ previousApplication.vat_number }}</strong> με τα ακόλουθα στοιχεία:</p>
      
      <div class="previous-application-details">
        <div class="detail-row">
          <span class="detail-label">Αριθμός Αίτησης:</span>
          <span class="detail-value">{{ previousApplication.aa_number }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Ημερομηνία:</span>
          <span class="detail-value">{{ formatDate(previousApplication.datetime) }}</span>
        </div>
        
        <ng-container *ngFor="let subsidy of previousApplication.subsidy; let i = index">
          <div class="meter-group">
            <div class="meter-header">Παροχή {{ i + 1 }}</div>
            <div class="detail-row">
              <span class="detail-label">Αριθμός Παροχής:</span>
              <span class="detail-value">{{ subsidy.meter_id }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Κατάσταση:</span>
<span class="detail-value" [ngClass]="{'status-success': subsidy.status === 'success', 'status-rejected': subsidy.status === 'rejected', 'status-pending': subsidy.status === 'pending'}">
  {{ subsidy.status === 'success' ? 'Επιτυχής' : (subsidy.status === 'rejected' ? 'Απορριφθείσα' : 'Σε αναμονή') }}
</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Επιδότηση:</span>
              <span class="detail-value">{{ subsidy.status === 'pending' ? '-' : subsidy.total_subsidy.toFixed(2) + '€' }}</span>
            </div>
          </div>
        </ng-container>
      </div>
      
      
      
      <div class="recall-actions">
        <button class="btn-secondary" (click)="closeImmediateRecallPrompt(false)">Διατήρηση & Αποσύνδεση</button>
        <button class="btn-primary" (click)="closeImmediateRecallPrompt(true)">Ανάκληση και Υποβολή νέας</button>
      </div>
    </div>
  </div>
</div> -->

<!-- Main content container - Only show when not loading and not showing recall prompt -->
<div class="eligibility-container animate-card" *ngIf="!loadingProgress && !showImmediateRecallPrompt">
  <div class="eligibility-card">
    <div class="card-header">
      <h2>{{title}}</h2>
      <!-- Added recall button -->
      <button 
        *ngIf="hasPreviousApplications" 
        class="recall-button" 
        (click)="openRecallDialog()"
      >
        <span class="recall-icon">↺</span> Ανάκληση Προηγούμενης Αίτησης
      </button>
    </div>
    
    <div class="card-body">
      <!-- Loading spinner -->
      <div *ngIf="isLoading" class="loading-container">
        <div class="spinner"></div>
        <p>Φόρτωση αποτελεσμάτων...</p>
      </div>
      
      <!-- Error message -->
      <div *ngIf="!isLoading && errorMessage" class="error-message">
        <div class="error-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <p>{{ errorMessage }}</p>
      </div>
      
      <!-- Results table -->
<!-- Results table -->
<div *ngIf="!isLoading && !errorMessage && meterDetails.length > 0" class="eligibility-results">
  <div class="meters-table-container">
    <table class="meters-table">
      <thead>
        <tr>
          <th>Ποσό Επιδότησης</th>
          <th>Αριθμός Παροχής</th>
          <th>ΚΑΔ</th>
          <th>Κατανάλωση</th>
          <th>Ποσοστό επιδότησης</th>
          <th>Επεξήγηση</th>
          <th>Κατάσταση</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let meter of getMetersArray()" [ngClass]="{'success-row': meter.eligible, 'rejected-row': !meter.eligible && meter.status === 'rejected', 'pending-row': !meter.eligible && meter.status === 'pending'}">
          <td class="meter-amount">
            <span *ngIf="meter.status === 'success'" class="amount-value">{{ meter.subsidyAmount }}€</span>
            <span *ngIf="meter.status === 'rejected' || meter.status === 'pending'" class="amount-none">{{ meter.subsidyAmount }}</span>
          </td>
          <td class="meter-number">{{ meter.value }}</td>
          <td class="meter-kad">{{ meter.kad }}</td>
        <td class="meter-consumption">
  {{ meter.consumption === 0 ? 'Μη διαθέσιμη' : meter.consumption + ' kWh' }}
</td>
<td class="meter-subsidy-rate">{{ meter.applicable_ratio ? (meter.applicable_ratio * 100).toFixed(2) + ' %' : '-' }}</td>
          <td class="meter-explanation">
            <span [innerHTML]="meter.explanation"></span>
          </td>
          <td class="meter-status">
            <div *ngIf="meter.eligible" class="status-indicator success">
              <div class="status-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <span>Αποδεκτή</span>
            </div>
            <div *ngIf="!meter.eligible && meter.status === 'rejected'" class="status-indicator rejected">
              <div class="status-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="15" y1="9" x2="9" y2="15"></line>
                  <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
              </div>
              <span>Απορρίφθηκε</span>
            </div>
            <div *ngIf="!meter.eligible && meter.status === 'pending'" class="status-indicator pending">
              <div class="status-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
              </div>
              <span>Σε αναμονή</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
    </div>
    
    <div class="card-footer">
      <div class="action-buttons">
        <button class="primary-button" (click)="proceedToNext()" [disabled]="isLoading || hasError">
          Ολοκλήρωση
          <span class="button-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup overlay (hidden by default) -->
<div class="popup-overlay" *ngIf="showPopup">
  <div class="popup-container">
    <div class="popup-content">
      <h3>Επιβεβαίωση</h3>
      <p>Η αίτηση σας με αρ. <strong>{{ requestID }}</strong> καταχωρήθηκε με επιτυχία. Θα λάβετε email επιβεβαίωσης.</p>
      <div class="popup-actions">
        <button class="popup-logout-button" (click)="logoutKeycloak()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          Αποσύνδεση
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Added recall dialog -->
<!-- <div *ngIf="showRecallDialog" class="modal-overlay">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Ανάκληση Προηγούμενης Αίτησης</h2>
      </div>
      <div class="modal-body">
        <p>Είστε βέβαιοι ότι θέλετε να ανακαλέσετε την προηγούμενη αίτηση με αριθμό {{previousRequestID}} για το ΑΦΜ σας;</p>
        <p>Αυτή η ενέργεια θα ακυρώσει την τρέχουσα αίτηση και όλα τα δεδομένα που έχετε υποβάλει.</p>
      </div>
      <div class="modal-footer">
        <button class="btn-secondary" (click)="closeRecallDialog()">Άκυρο</button>
        <button class="btn-primary" (click)="sendRecallRequest()">Ανάκληση</button>
      </div>
    </div>
  </div>
</div> -->

<!-- Added success dialog -->
<div *ngIf="showSuccessDialog" class="modal-overlay">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Ενημέρωση</h2>
      </div>
      <div class="modal-body">
        <p>{{ successMessage }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn-primary" (click)="closeSuccessDialog()">Εντάξει</button>
      </div>
    </div>
  </div>
</div>